var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navegacion__container"},_vm._l((_vm.rutas),function(ruta){return _c('button',{key:ruta.id,class:_vm.getClasses(ruta),on:{"click":function($event){return _vm.$goTo(ruta.to.name)}}},[_vm._v(" "+_vm._s(ruta.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }